module.exports = __webpack_public_path__ + "img/teach7.299a1f9d.jpg";